_ = require 'underscore'

{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
Util = require 'app/scripts/lib/util'

BoardCleanUpView = require 'app/scripts/views/board/board-clean-up-view'
Auth = require 'app/scripts/db/auth'
l = require 'app/scripts/lib/localize'
headerTemplate = require 'app/scripts/views/templates/board_header'
CopyBoardHeaderButtonTeams = require 'app/scripts/data/copy-board-header-button-teams'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ logoDomain } = require '@trello/config'
Dialog = require 'app/scripts/views/lib/dialog'

module.exports.renderBoardHeader = ->
  isPremOrgAdmin = @model.isPremOrgAdmin(Auth.me())

  data =
    name: @model.get('name')
    canRename: isPremOrgAdmin || @model.owned()
    isLoggedIn: Auth.isLoggedIn()
    isAdmin: @model.ownedByMember(Auth.me())
    isMember: @model.isMember(Auth.me())
    isPrivateTeam: @model.hasOrganization() && !@model.getOrganization()
    isPrivateTeamForEnterpriseVisibleBoard: @model.hasOrganization() && @model.getPref('permissionLevel') == 'enterprise'
    isUntitled: @model.get('name') == l(['untitled board'])
    canJoin: @model.canJoin()
    canInviteMembers: @model.canInviteMembers()
    selfJoin: @model.allowsSelfJoin()
    canAssign: @model.editable()
    boardCardCount: @model.openCards()?.filter((card) => @model.filter.satisfiesFilter(card)).length
    isTemplate: @model.isTemplate()

  data.starTooltipKey = if @model.isTemplate()
      'click-to-star-or-unstar-this-template-starred-templates-show-up-at-the-top-of-your-boards-list'
    else
      'click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list'

  organization = @model.getOrganization()
  if organization?
    data.orgDisplayName = organization.get('displayName')
    data.orgName = organization.get('name')
    data.showCopyButton = _.contains(CopyBoardHeaderButtonTeams, organization.id)
    _hash = organization.get('logoHash')
    enterprise_hash = organization.getEnterprise()?.get('logoHash')
    if enterprise_hash && featureFlagClient.get('enterprise.corporate-visibility', false)
      data.orgLogoUrl = "#{logoDomain}/#{enterprise_hash}/30.png"
      data.orgLogoUrl2x = "#{logoDomain}/#{enterprise_hash}/170.png"
    else if _hash
      data.orgLogoUrl = "#{logoDomain}/#{_hash}/30.png"
      data.orgLogoUrl2x = "#{logoDomain}/#{_hash}/170.png"
    data.hasBusinessClass = organization.isPremium()
    data.isBusinessClass = organization.isBusinessClass()
    data.isEnterprise = organization?.get('idEnterprise')

  @$('.js-board-header').html headerTemplate(data)

  @renderPermissionLevel()
  @renderBoardHeaderCalendar()
  @renderBoardHeaderSubscribed()
  @renderBoardHeaderMap()
  @renderFilteringStatus()
  @renderBoardHeaderStarred()
  @renderPluginButtons()
  @renderBoardHeaderFacepile()
  @renderBoardBackgroundPromptPopover()
  @renderBoardTemplateBadge()

  @

module.exports.renderBoardHeaderStarred = ->
  @$('.js-star-board').toggleClass('board-header-btn-enabled', @model.isStarred())
  @

module.exports.toggleStarred = ->
  boardStarList = Auth.me().boardStarList

  if boardStarList.getBoardStar(@model.id)?
    boardStarList.unstarBoard(@model.id)
    track("Board Header", "Unstar Board")
  else
    boardStarList.starBoard(@model.id)
    track("Board Header", "Star Board")

  if @sendGASEvent
    Analytics.sendTrackEvent
      action: 'set'
      actionSubject: 'boardStar'
      source: 'boardScreen'
      containers:
        board:
          id: @model.id
      attributes:
        isEnabled: !!boardStarList.getBoardStar(@model.id)

  @

module.exports.openFilter = (e) ->
  Util.stop(e)
  track("Board Header", "Open Filtering via Header")
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'boardFilterButton'
      source: 'boardScreen'

  @sidebarView.pushView 'filter'
  return

module.exports.clearFilters = (e) ->
  Util.stop(e)
  track("Board Header", "Clear Filtering via Header")
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'clearBoardFilterButton'
      source: 'boardScreen'

  @model.filter.clear()
  return

module.exports.showCleanUp = (e) ->
  Util.stop(e)

  track("Board Header", "Show Clean-Up")

  view = new BoardCleanUpView({ @model, @modelCache })
  Dialog.show
    view: view
    maxWidth: 800
    hide: ->
      view.abort()

  return
